import * as L from 'leaflet';
/**
 * The image legend control's default options.
 */
const CONTROL_LEGEND_IMAGE_OPTIONS_DEFAULT = {
    position: 'bottomleft',
    fallback: L.Util.emptyImageUrl,
    altText: '',
};
/**
 * The image legend control.
 */
export class ControlLegendImage extends L.Control {
    /**
     * Create a new image legend control instance.
     * @param options - The image legend control options.
     */
    constructor(options) {
        super(Object.assign(Object.assign({}, CONTROL_LEGEND_IMAGE_OPTIONS_DEFAULT), options));
    }
    /**
     * The hook to execute when the control is added to the map.
     * @returns The container element to be added to the map.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#control-extension-methods}
     */
    onAdd() {
        const container = L.DomUtil.create('div', 'widget-control-imagelegend');
        if (this.options.url) {
            const image = L.DomUtil.create('img');
            if (this.options.width) {
                image.width = this.options.width;
            }
            if (this.options.height) {
                image.height = this.options.height;
            }
            image.alt = this.options.altText;
            image.onerror = () => {
                image.src = this.options.fallback;
                image.onerror = null;
            };
            image.src = this.options.url;
            container.appendChild(image);
        }
        return container;
    }
    /**
     * The hook to execute when the control is removed from the map.
     * @see {@link https://leafletjs.com/reference-1.7.1.html#control-extension-methods}
     */
    onRemove() {
        // do nothing
    }
}
//# sourceMappingURL=ControlLegendImage.js.map